"use client";
import LoadingComponent from "@/components/loading_component/loading_component";
export const metadata = {
    title: "Loading",
    description: "Loading page for issues",
}; 

export default function Loading() {

    return (
        <LoadingComponent/>
    );
}